import { CalendarDays, Hash, IdCard, MapPin, Phone, Tag } from 'lucide-react';
import { PersonDetailHero, type PersonDetailFact } from '@/components/common/PersonDetailHero';
import { PillBadge } from '@/components/common/PillBadge';
import { EMPTY_VALUE } from '@/constants/app.constants';
import type { FeedbackListItem } from '../types/feedback.types';
import { formatFeedbackEntryTime } from '../utils/feedbackEntryTime';
import { FeedbackCompletionBadge } from './FeedbackCompletionBadge';
import { FeedbackReadState } from './FeedbackReadState';

function getIdentityFacts(feedback: FeedbackListItem | undefined): PersonDetailFact[] {
  const user = feedback?.user;
  return [
    { key: 'login', icon: Hash, label: 'Login name', value: user?.username },
    { key: 'hrId', icon: IdCard, label: 'HR ID', value: user?.hrEmpId },
    { key: 'mobile', icon: Phone, label: 'Mobile', value: user?.mobile },
    { key: 'thana', icon: MapPin, label: 'Thana', value: user?.thana },
  ];
}

interface FeedbackDetailHeroProps {
  feedback: FeedbackListItem | undefined;
}

export function FeedbackDetailHero({ feedback }: FeedbackDetailHeroProps) {
  return (
    <PersonDetailHero
      ariaLabel="Feedback summary"
      name={feedback?.user?.fullName}
      facts={getIdentityFacts(feedback)}
      isLoading={feedback === undefined}
      aside={
        feedback ? (
          <>
            <div className="flex items-center gap-2.5">
              <FeedbackCompletionBadge status={feedback.status} />
              <FeedbackReadState readAt={feedback.readAt} />
            </div>
            <div className="flex flex-wrap gap-2 sm:justify-end">
              <PillBadge icon={Tag} screenReaderLabel="Feedback type">
                {feedback.type?.name ?? EMPTY_VALUE}
              </PillBadge>
              <PillBadge icon={CalendarDays} screenReaderLabel="Entry time">
                {formatFeedbackEntryTime(feedback)}
              </PillBadge>
            </div>
          </>
        ) : null
      }
    />
  );
}
